import { formatDayOfYear } from '~/constants';
import { BillingDayOfMonthModel, serviceBillingModel, serviceModel } from '~/models';
import { RecurrencePeriodTypes } from '~/models/service-billing';
export const autoBillingTextsPath = 'billing.automaticBilling';
export const commonDaysOfWeekTextsPath = 'common.daysOfWeek';
function localizedDayOfWeek(dayOfWeek, texts) {
    const key = dayOfWeek.toLowerCase();
    return texts[key]();
}
const dayOfMonthBullet = (dayOfMonth, recurrencePeriod, autoBillingTexts)=>{
    const normalized = BillingDayOfMonthModel.make(dayOfMonth);
    const isQuarter = recurrencePeriod === RecurrencePeriodTypes.Quarterly;
    const dayParam = {
        day: normalized.formatDay()
    };
    if (normalized.isLast() && isQuarter) {
        return {
            text: autoBillingTexts.billedQuarterlyOnLastDay(),
            periodText: autoBillingTexts.periodQuarterlyOnLastDay()
        };
    }
    if (normalized.isLast()) {
        return {
            text: autoBillingTexts.billedMonthlyOnLastDay(),
            periodText: autoBillingTexts.periodMonthlyOnLastDay()
        };
    }
    if (isQuarter) {
        return {
            text: autoBillingTexts.billedQuarterlyOnDay(dayParam),
            periodText: autoBillingTexts.periodQuarterlyOnDay(dayParam)
        };
    }
    return {
        text: autoBillingTexts.billedMonthlyOnDay(dayParam),
        periodText: autoBillingTexts.periodMonthlyOnDay(dayParam)
    };
};
export const autoBillingPeriodLabel = (billing, autoBillingTexts, commonDaysOfWeek)=>{
    const billingDayOfWeek = serviceBillingModel.billingDayOfWeek(billing);
    const billingDayOfMonth = serviceBillingModel.billingDayOfMonth(billing);
    const billingDayOfYear = serviceBillingModel.billingDayOfYear(billing);
    const recurrencePeriod = serviceBillingModel.isOngoing(billing) && serviceModel.recurrencePeriod(billing);
    if (recurrencePeriod === RecurrencePeriodTypes.Weekly && billingDayOfWeek) {
        const dayOfWeek = localizedDayOfWeek(billingDayOfWeek, commonDaysOfWeek);
        return {
            text: autoBillingTexts.billedEveryDay({
                dayOfWeek
            }),
            periodText: autoBillingTexts.periodEveryDay({
                dayOfWeek
            })
        };
    } else if (recurrencePeriod === RecurrencePeriodTypes.BiWeekly && billingDayOfWeek) {
        const dayOfWeek = localizedDayOfWeek(billingDayOfWeek, commonDaysOfWeek);
        return {
            text: autoBillingTexts.billedEveryOtherDay({
                dayOfWeek
            }),
            periodText: autoBillingTexts.periodEveryOtherDay({
                dayOfWeek
            })
        };
    } else if (recurrencePeriod === RecurrencePeriodTypes.Monthly && billingDayOfMonth) {
        return dayOfMonthBullet(billingDayOfMonth, recurrencePeriod, autoBillingTexts);
    } else if (recurrencePeriod === RecurrencePeriodTypes.Quarterly) {
        return dayOfMonthBullet(serviceBillingModel.isBilledUpfront(billing) ? 1 : 'last', recurrencePeriod, autoBillingTexts);
    } else if (recurrencePeriod === RecurrencePeriodTypes.Yearly && billingDayOfYear) {
        const dateParam = {
            date: formatDayOfYear(billingDayOfYear)
        };
        return {
            text: autoBillingTexts.billedOnDateAnnually(dateParam),
            periodText: autoBillingTexts.periodOnDateAnnually(dateParam)
        };
    } else {
        return null;
    }
};
